/**
 * Copyright IBM Corp. 2022, 2026
 */

import Image, { type ImageProps } from 'next/image'
import * as Dialog from '@radix-ui/react-dialog'
import { Button } from '@hashicorp/mds-react'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import s from './style.module.css'

interface ImageLightboxProps {
	onDismiss: () => void
	image: ImageProps
}

export default function ImageLightbox({
	onDismiss,
	image,
}: ImageLightboxProps) {
	return (
		<Dialog.Root
			open={true}
			onOpenChange={(isOpen) => {
				!isOpen && onDismiss()
			}}
		>
			<Dialog.Portal>
				<Dialog.Overlay className={s.dialogOverlay} />

				<Dialog.Content className={s.dialogContent}>
					<VisuallyHidden asChild>Image</VisuallyHidden>
					<div className={s.image}>
						<Image
							src={image.src}
							alt={image.alt}
							width={image.width}
							height={image.height}
							priority
						/>
					</div>
					<div className={s.closeIconBttnWrapper}>
						<Button onClick={onDismiss} icon="x" color="secondary" />
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	)
}
